import {AxiosError} from 'axios';
import {ResponseError} from 'types/ResponseError';

export const getAxiosErrorMessage = (err: AxiosError<ResponseError>) => {
   const message = err.response?.data.errors?.map((e) => e.message).join('/n');
   //    console.debug('get axios error', err, message);
   return message;
};
